export default {
  editTitle: 'Editar Otimização de Plano',
  newTitle: 'Nova Otimização de Plano',
  save: 'Salvar',
  create: 'Criar',
  advancedSettings: 'Configurações Avançadas',
  planName: 'Nome do Plano',
  startDate: 'Data de início',
  endDate: 'Data de fim',
  budget: 'Orçamento Total',
  budgetRestrictions: 'Restrições de orçamento',
  mediaTouchpoints: 'Ativar/Desativar Pontos de Contato',
  segments: 'Segmentos',
  nameRequired: 'O nome é obrigatório',
  dateRequired: 'A data é obrigatória',
  mustBeAfterStartDate: 'Deve ser posterior à data de início',
  budgetRequired: 'O orçamento é obrigatório',
  restrictionsForceOverBudget: '(As restrições forçam um investimento superior ao orçamento)',
  timeRestrictionsForceOverBudget: '(As restrições de tempo forçam um investimento superior ao orçamento)',
  restrictionsForceUnderBudget: '(As restrições forçam um investimento inferior ao orçamento)',
  invalidRestrictionLessThanZero: '(Restrição inválida. Não é possível investir menos que zero)',
  invalidRestrictionMinOverMax: '(Restrição inválida. O mínimo não pode ser maior que o máximo)',
  tryNewOptimizer: 'Experimentar o novo otimizador?',
  betaUnavailableTooltip: 'O novo otimizador ainda não está disponível para este modelo.',
  budgetAllocationRequirement: 'Requisito de Alocação de Orçamento',
  mustSpendExactly: 'Deve gastar exatamente',
  canSpendUpTo: 'Pode gastar até',
  restrictions: 'Restrições',
  externalVariablesOptional: 'Variáveis Externas (opcional)',
  kpiWeighting: 'Ponderação de KPI',
  kpiAutoBalance: 'Auto-Balance',
  kpiCustomWeights: 'Pesos Personalizados por KPI',
  kpiWeightsTotal: 'Total',
  kpiWeightsMustEqual100: 'Os pesos devem somar 100%',
  kpiWeightingHint: 'Atribua pesos a cada KPI. O otimizador priorizara canais e taticas que impulsionem esses resultados. O total deve ser igual a 100%.',
  enableTime: 'Habilitar Restrições Temporais',
  timeRestrictions: 'Restrições de tempo',
  selectDateRange: 'Selecione um intervalo de datas válido para configurar restrições de tempo',
  dateChangeBlockedByRestrictions: 'Não é possível alterar as datas do plano. As restrições temporais existentes fazem referência a meses que ficariam fora do novo período. Remova ou edite essas restrições primeiro.',
  feasibleChip: 'Plano viável',
  feasibility_infeasible: 'Estas restrições não podem ser atendidas. Flexibilize as restrições ou ajuste o orçamento.',
  feasibility_channelMinExceedsCapacity: '{channel} não consegue atingir o mínimo exigido neste período. Reduza o mínimo ou amplie o intervalo de datas.',
  feasibility_channelMinExceedsMax: '{channel} tem um mínimo maior que o máximo. Corrija essa restrição.',
  feasibility_sumOfMinimumsExceedsBudget: 'Os mínimos exigidos somam mais do que o orçamento. Reduza alguns mínimos ou aumente o orçamento.',
  feasibility_budgetExceedsMaxCapacity: 'O orçamento é maior do que os canais selecionados conseguem absorver neste período. Reduza o orçamento, adicione canais ou flexibilize os máximos.',
  feasibility_groupMinExceedsCapacity: '{channels} juntos não conseguem atingir o mínimo exigido neste período. Reduza esse mínimo ou amplie o intervalo de datas.',
  feasibility_groupMinExceedsMax: 'A restrição combinada de {channels} tem um mínimo maior que o máximo. Corrija essa restrição.',
  feasibility_channelConflictingRestrictions: 'As restrições de {channel} entram em conflito entre si: uma exige gastar mais do que outra permite. Corrija essas restrições.',
  feasibility_restrictionOnUnselectedChannel: '{channels} tem uma restrição mas está desmarcado em Pontos de Contato. Remova a restrição ou selecione o canal novamente.',
  feasibility_noChannelsSelected: 'Nenhum canal de mídia está selecionado. Selecione pelo menos um ponto de contato.'
}
